var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 73,
    viewBox: "0 0 91 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 8.27177C52.0368 4.49062 59.4519 2.5 67 2.5C74.5481 2.5 81.9632 4.49062 88.5 8.27177V70.5C81.9632 66.7188 74.5481 64.7282 67 64.7282C59.4519 64.7282 52.0368 66.7188 45.5 70.5C38.9632 66.7188 31.5481 64.7282 24 64.7282C16.4519 64.7282 9.03683 66.7188 2.5 70.5V8.27177C9.03683 4.49062 16.4519 2.5 24 2.5C31.5481 2.5 38.9632 4.49062 45.5 8.27177ZM45.5 70.5V8.27177",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e87b325b89724e4c12e86df196e87c08.svg";
export { ForwardRef as ReactComponent };